export default {
    apiLogsData: (state) => state.apiLogsData,
    apiLogFields: (state) => state.apiLogFields,
    apiLogModules: (state) => state.apiLogModules,
    apiLogActions: (state) => state.apiLogActions,
    totalRecords: (state) => state.totalRecords,
}
